import { LookupModelSearchEvent } from "@mcleod/components";
import { AutogenLayoutOrderUsers } from "./autogen/AutogenLayoutOrderUsers";

const LME_USER_TYPE = "U";

export class OrderUsers extends AutogenLayoutOrderUsers {

    override onLoad() {
        const LME_USER_FILTER = (event: LookupModelSearchEvent) => { event.filter.web_user_type = LME_USER_TYPE };
        this.textboxBillingUserId.addBeforeLookupModelSearchListener(LME_USER_FILTER);
        this.textboxOperationsUser.addBeforeLookupModelSearchListener(LME_USER_FILTER);
        this.textboxEnteredUserId.addBeforeLookupModelSearchListener(LME_USER_FILTER);
    }
}
